import React from 'react';
import css from './ListingPage.module.css';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import { Button, IconCollection, Ratings } from '../../components';
import { normalizeString } from '../../util/data';

function copyCurrentPageUrl() {
    const url = window.location.href;

    // Copy to clipboard
    navigator.clipboard.writeText(url).then(() => {
        alert('URL copied to clipboard!');
    }).catch(err => {
        console.error('Failed to copy URL:', err);
    });

    return url;
}


const ListingPageHeader = ({
    className,
    pills,
    title,
    rating,
    reviews,
    city,
    region,
    country,
    listingDistance,
    showInMiles,
}) => {
    const getPillClass = (pill, idx) => {
        const text = pill.toLowerCase();
        const pillClasses = [
            css.pillNew,
            css.pillRefund,
            css.pillDelivery,
            css.pillEnvironment
        ];

        if (text.includes('new')) return `${css.pill} ${css.pillNew}`;
        if (text.includes('easy')) return `${css.pill} ${css.pillRefund}`;
        if (text.includes('delivery')) return `${css.pill} ${css.pillDelivery}`;
        if (text.includes('environment'))
            return `${css.pill} ${css.pillEnvironment}`;
        return `${css.pill} ${pillClasses[idx % pillClasses.length]}`;
    };

    const distance = showInMiles ? listingDistance?.miles : listingDistance?.kilometers;

    return (
        < >
            <div
                className={classNames(
                    css.pillsContainer,
                    className
                )}
            >
                <div className={css.pillsContainerContent}>
                    {pills.length && (
                        <div className={css.pills}>
                            {pills.map((pill, idx) =>
                            (

                                <div key={pill} className={getPillClass(pill, idx)}>
                                    <span>{normalizeString(pill)}</span>
                                </div>
                            ))}
                        </div>
                    )}
                    <h1 className={css.title}>{title}</h1>
                    <div className={css.ownerInitialInfo}>
                        <div className={css.locationWrapper}>
                            <div className={css.ratingWrapper}>
                                <div className={css.ratingContent}>
                                    <Ratings className={css.ratings} rating={rating || 5} />
                                </div>
                                <span className={css.ratingText}>
                                    <FormattedMessage
                                        id="OrderPanel.reviewsCount"
                                        values={{ count: reviews?.length }}
                                    />
                                </span>
                            </div>
                            <i className="ri-map-pin-2-line" style={{ fontSize: '18px', color: '#101828' }}></i>
                            {distance !== null && distance !== undefined && showInMiles ? (
                                <div className={css.locationText}>
                                    <span>{distance} miles away -</span>
                                </div>
                            ) : distance !== null && distance !== undefined && !showInMiles ? (
                                <div className={css.locationText}>
                                    <span>{distance} km away -</span>
                                </div>
                            ) : null}
                            <div className={css.locationText}>
                                <span>{city + ((region || country) ? ", " + (region || country) : '')}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={css.shareButton}>
                    <Button
                        icon={<IconCollection name="share_icon" />}
                        arrow="left"
                        variant="secondary-outline"
                        onClick={copyCurrentPageUrl}
                    >
                        Share
                    </Button>
                </div>
            </div>

        </>
    );
};

export default ListingPageHeader;
